import type { DemoKey } from '../types';

export const te: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'గణితం · గణాంకాలు',
  'app.title': 'గణాంకాలు',
  'panel.experiment': 'దృశ్యం',
  'panel.params': 'పారామితులు',

  'exp.survey-explorer.title': 'సర్వే ఎక్స్‌ప్లోరర్',
  'exp.survey-explorer.desc': 'ఒక కాలమ్ ఎంచుకోండి; డెమో సరైన సారాంశం ఎంచుతుంది.',
  'exp.distribution-sculptor.title': 'వంపు శిల్పి',
  'exp.distribution-sculptor.desc': 'బిందువులను లాగి గణాంకాల స్పందన చూడండి.',
  'exp.two-variable-lab.title': 'ద్విచర ప్రయోగశాల',
  'exp.two-variable-lab.desc': 'వ్యాప్తి, అనుగుణత, మరియు కారణ ప్రశ్న.',
  'exp.sampling-lab.title': 'నమూనా ప్రయోగశాల',
  'exp.sampling-lab.desc': 'విధానం, పరిమాణం నమూనా సగటును ఎలా జరుపుతాయి.',
  'exp.probability-diagrams.title': 'సంభావ్యత చిత్రాలు',
  'exp.probability-diagrams.desc': 'మిశ్రమ ఘటనల వెన్ మరియు చెట్టు దృశ్యాలు.',

  'type.qualitative-nominal.label': 'గుణాత్మక · నామకీయ',
  'type.qualitative-nominal.def': 'క్రమం లేని వర్గాలు.',
  'type.qualitative-ordinal.label': 'గుణాత్మక · క్రమబద్ధ',
  'type.qualitative-ordinal.def': 'అర్థవంతమైన క్రమం ఉన్న వర్గాలు.',
  'type.qualitative-multi.label': 'గుణాత్మక · బహుళ',
  'type.qualitative-multi.def': 'ప్రతి పరిశీలనకు అనేక ట్యాగ్‌లు ఉండొచ్చు.',
  'type.quantitative-discrete.label': 'పరిమాణాత్మక · వివక్ష',
  'type.quantitative-discrete.def': 'స్థిర దశల్లో సంఖ్యలు.',
  'type.quantitative-continuous.label': 'పరిమాణాత్మక · అవిచ్ఛిన్న',
  'type.quantitative-continuous.def': 'అవిచ్ఛిన్న స్కేల్‌లో కొలిచిన సంఖ్యలు.',

  'column.name.label': 'విద్యార్థి పేరు',
  'column.height_cm.label': 'ఎత్తు',
  'column.shoe_size_eu.label': 'జోడు సైజు (EU)',
  'column.study_hours.label': 'వారానికి చదువు గంటలు',
  'column.test_score.label': 'పరీక్ష స్కోర్',
  'column.sports_played.label': 'ఆడిన క్రీడలు',
  'column.eye_color.label': 'కంటి రంగు',
  'column.commute_min.label': 'ప్రయాణం',
  'column.grade_year.label': 'తరగతి',
  'column.homework_effort.label': 'హోమ్‌వర్క్ శ్రమ',
  'column.ice-cream-sales.label': 'ఐస్‌క్రీం అమ్మకాలు',
  'column.drownings.label': 'మునక మరణాలు',
  'column.month.label': 'నెల',
  'column.storks.label': 'కొంగలు',
  'column.births.label': 'జననాలు',
  'column.country_area_km2.label': 'దేశ విస్తీర్ణం',
  'column.sleep_hours.label': 'నిద్ర గంటలు',
  'column.reaction_ms.label': 'ప్రతిస్పందన సమయం',

  'dataset.master-survey.label': 'తరగతి సర్వే',
  'dataset.master-survey.desc': '30 సిమ్యులేటెడ్ విద్యార్థులు.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'ఐస్‌క్రీం vs మునకలు',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'రెండూ ఋతువుతో పెరుగుతాయి-తగ్గుతాయి. మునకలు అమ్మకాలకు కారణం కాదు.',
  'dataset.spurious-storks-vs-births.label': 'కొంగలు vs జననాలు',
  'dataset.spurious-storks-vs-births.desc':
    'పెద్ద దేశాల్లో ఎక్కువ కొంగలు, ఎక్కువ జననాలు. పక్షులు కారణం కావు.',
  'dataset.real-sleep-vs-reaction-time.label': 'నిద్ర vs ప్రతిస్పందన',
  'dataset.real-sleep-vs-reaction-time.desc':
    'ఎక్కువ నిద్ర, వేగంగా ప్రతిస్పందన. నిజమైన ఋణాత్మక సంబంధం — సహేతుక యంత్రాంగంతో.',

  'tag.football.label': 'ఫుట్‌బాల్',
  'tag.basketball.label': 'బాస్కెట్‌బాల్',
  'tag.volleyball.label': 'వాలీబాల్',
  'tag.swimming.label': 'ఈత',
  'tag.none.label': 'ఏదీ లేదు',

  'population.gaussian.label': 'గంట వక్రం',
  'population.right-skewed.label': 'కుడివైపు వంగిన',
  'population.bimodal.label': 'రెండు శిఖరాలు',
  'population.uniform.label': 'ఏకరూపం',

  'venn.dice-even-or-prime.label': 'పాచిక: సరి లేదా ప్రధాన',
  'venn.class-sports-2set.label': 'క్రీడలు (2 సమితులు)',
  'venn.class-sports-3set.label': 'క్రీడలు (3 సమితులు)',
  'venn.custom.label': 'అనుకూల',

  'tree.draw-without-replacement.label': 'తిరిగి పెట్టకుండా',
  'tree.custom.label': 'అనుకూల',
  'tree.coin.heads': 'బొమ్మ',
  'tree.coin.tails': 'బొరుసు',
  'tree.draw.start': 'సంచి: 2 ఎరుపు, 3 నీలం',
  'tree.draw.red': 'ఎరుపు',
  'tree.draw.blue': 'నీలం',
  'tree.custom.start': 'ప్రారంభం',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'హిస్టోగ్రాం',
  'card.cumulative': 'సంచిత వారంవంశం',
  'card.box': 'బాక్స్ ప్లాట్',
  'card.summary': '5-సంఖ్య సారాంశం',
  'card.bar': 'బార్ చార్ట్',
  'card.mode': 'బహుళ',
  'card.tag-frequency': 'ట్యాగ్ వారంవంశం',
  'card.mode-tag': 'శిఖర ట్యాగ్',
  'card.empty-no-order': 'వర్తించదు',
  'card.empty-multi': 'వర్తించదు',
  'card.numberline': 'సంఖ్యా రేఖ',
  'card.scatter': 'వ్యాప్తి',
  'card.description': 'ఏం జరుగుతోంది',
  'card.population': 'జనాభా',
  'card.sampling-distribution': 'నమూనా సగటులు',
  'card.venn': 'వెన్',
  'card.tree': 'చెట్టు',
  'card.probabilities': 'సంభావ్యతలు',

  'param.dataset.label': 'డేటాసెట్',
  'param.column.label': 'కాలమ్',
  'param.bins.label': 'బిన్‌లు',
  'param.shape.label': 'ప్రారంభ ఆకారం',
  'param.show-mean.label': 'సగటు చూపండి',
  'param.show-median.label': 'మధ్యగతం చూపండి',
  'param.x-col.label': 'X కాలమ్',
  'param.y-col.label': 'Y కాలమ్',
  'param.show-regression.label': 'రిగ్రెషన్ లైన్',
  'param.show-residuals.label': 'మిగులు',
  'param.show-confounder.label': 'మిళిత చర చూపండి',
  'param.population.label': 'జనాభా',
  'param.technique.label': 'పద్ధతి',
  'param.sample-size.label': 'నమూనా పరిమాణం',
  'param.stratum.label': 'స్తరం',
  'param.bias.label': 'పక్షపాతం',
  'param.mode.label': 'మోడ్',
  'param.preset.label': 'ప్రీసెట్',
  'param.universe.label': 'విశ్వ పరిమాణం',
  'param.show-prob.label': 'సంభావ్యతలు చూపండి',
  'param.treat-as-numeric.label': 'సంఖ్యగా పరిగణించు',

  'stat.count': 'లెక్క',
  'stat.mean': 'సగటు',
  'stat.median': 'మధ్యగతం',
  'stat.range': 'వ్యాప్తి',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'అపసంఖ్యలు',
  'stat.r': 'పిర్సన్ r',
  'stat.r2': 'r²',
  'stat.slope': 'ఢాలు',
  'stat.intercept': 'అడ్డ-రేఖా ఖండం',
  'stat.n': 'n',
  'stat.population-mean': 'నిజ సగటు',
  'stat.latest-sample-mean': 'నమూనా సగటు',
  'stat.sample-mean-spread': 'నమూనా సగటు SD',
  'stat.sample-count': 'తీసిన నమూనాలు',
  'outlier.upper': 'పై అపసంఖ్యలు',
  'outlier.lower': 'కింది అపసంఖ్యలు',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'మళ్లీ నమూనా',
  'btn.run-100': '100 నమూనాలు తీయి',
  'btn.stop': 'ఆపండి',
  'btn.clear-history': 'చరిత్ర తొలగించండి',

  'explainer.no-order': 'క్రమం లేదు → సంచితం లేదు, బాక్స్ లేదు.',
  'explainer.multi-no-iqr': 'బహుళ → చతుర్థాంశాలు / IQR నిర్వచితం కాదు.',
  'message.no-data': 'డేటా లేదు.',
  'message.needs-quartiles': 'చతుర్థాంశాలకు ≥4 బిందువులు అవసరం.',
  'message.x-zero-variance': 'X విస్తరణ సున్నా — రేఖ సరిపోదు.',
  'message.n-too-small': 'n చాలా చిన్నది.',
  'message.stratum-clamp': 'స్తరంలో అడిగినదానికంటే తక్కువ వరుసలు — అన్నీ వాడాం.',
  'message.siblings-sum-to-one': 'తోటి పిల్లల మొత్తం 1 కావాలి.',
};
